import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    OrderStatuses, OrderTypes, ProductType,
} from 'app/enums/label.enums'

import {
    InboundOrdersType,
} from '../ScenarioEditor.types'

const config: SkyNetTableConfig<keyof InboundOrdersType> = {
    name: 'InboundOrders',
    fields: [
        {
            name: 'orderNumber',
            width: '160px',
            labelKey: 'DailyOpsView.orderNumber',
            componentName: 'OrderTableLink',
        },
        {
            name: 'orderStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderStatuses,
            filterField: 'orderStatus',
            filterType: FilterType.Array,
            labelKey: 'DailyOpsView.orderStatus',
        },
        {
            name: 'orderType',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderTypes,
            labelKey: 'Order.orderType',
            filterField: 'orderType',
            filterType: FilterType.Array,
        },
        {
            name: 'from',
            labelKey: 'OrderBaseTabView.from',
        },

        {
            name: 'originLocationLocationName',
            filterField: 'originLocationLocationName',
            filterType: FilterType.Array,
            labelKey: 'Order.originLocation',
        },
        {
            name: 'estimatedArrival',
            sorting: false,
            labelKey: 'Order.estimatedDelivery',
        },
        {
            name: 'requiredContainers',
            componentName: 'RequiredContainersList',
            allowedValuesEnum: ProductType,
            sorting: false,
            labelKey: 'Order.requiredContainers',
            filterField: 'requiredContainers',
            filterType: FilterType.Array,
        },
    ],
}

export default config
